import './time-picker.scss';

import * as gzTimePickerDirective from './time-picker.directive';

export default angular.module('gazelle.components.timePicker', [
  'angularMoment'
])
  .directive(gzTimePickerDirective.name, gzTimePickerDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/time-picker/time-picker.module.js